import { render, staticRenderFns } from "./PT110ProductListParts.vue?vue&type=template&id=5fbb4b41&"
import script from "./PT110ProductListParts.vue?vue&type=script&lang=js&"
export * from "./PT110ProductListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports